// @flow
import React, { Component } from 'react';
import { Accordion, Icon, Grid, Button, Form, Divider, Message, Label } from 'semantic-grab-ui/src';
import formComponent from 'components/decorators/form_component';
import FormInputWithError from 'components/form/FormInputWithError';
import type { TridentCampaignDetails } from 'types/trident-campaigns';
import _ from 'lodash';
import './TreatmentForm.scss';
import Toastr from 'utils/toastr-util';

type Props = {
  model: TridentCampaignDetails,
  canActivate: boolean,
  currentNode: string,
  parentNode: string,
  parentKeyList: Array<string>,
  onModelChange: (_?: Object) => void,
  handleDeleteCount: Function,
  handleInputChange: Function,
  handleControlBlur: Function,
  handleCloseModal: Function,
  isAdd: boolean,
  handleDeleteNode: Function,
  isValid: Function,
  error: any,
  };

@formComponent()
export default class CounterBuilder extends Component {
  props: Props;
  constructor(props: Props) {
    super(props);
    this.state = {
      activeIndex: 0,
      originalModel: this.props.model,
    };
  }
  UNSAFE_componentWillReceiveProps(nextProps: Props) {
    if (_.get(nextProps.model.nodes[nextProps.currentNode], 'data.targets', []).length !== _.get(this.props.model.nodes[this.props.currentNode], 'data.targets', []).length) {
      const newActiveIndex = _.get(nextProps.model.nodes[nextProps.currentNode], 'data.targets', []).length - 1;
      this.setState({ activeIndex: newActiveIndex });
    }
  }
  handleClick = (e: any, titleProps: any) => {
    const { index } = titleProps;
    const { activeIndex } = this.state;
    const newIndex = activeIndex === index ? activeIndex : index;

    this.setState({ activeIndex: newIndex });
  }

  handleCountChange = (event: any, data: any, targetIndex: number) => {
    const updatedModel = _.cloneDeep(this.props.model);
    const targets = _.get(updatedModel.nodes[this.props.currentNode], 'data.targets', []);
    const target = targets[targetIndex];
    const getBy = target[0] === 'o' ? 'occurrence' : 'txAmount';
    const newTarget = getBy.concat('-', `${data.value}`);
    targets[targetIndex] = newTarget;
    _.set(updatedModel.nodes[this.props.currentNode], 'data.targets', targets);
    this.props.onModelChange(updatedModel);
  }
  handleByChange = (event: any, data: any, targetIndex: number) => {
    const updatedModel = _.cloneDeep(this.props.model);
    const targets = _.get(updatedModel.nodes[this.props.currentNode], 'data.targets', []);
    const target = targets[targetIndex];
    const getCount = target.match(/\d+/g) !== null ? target.match(/\d+/g)[0] : '1';
    const newTarget = data.value.concat('-', getCount);
    targets[targetIndex] = newTarget;
    _.set(updatedModel.nodes[this.props.currentNode], 'data.targets', targets);
    this.props.onModelChange(updatedModel);
  }
  cancelCounter = () => {
    if (this.props.isAdd) {
      // eslint-disable-next-line no-alert
      const confirmValue = confirm('Cancel will delete this inactive node. Are you sure to delete this?');
      if (!confirmValue) return;
      this.props.handleDeleteNode(this.props.parentNode, this.props.currentNode, -1);
    } else {
      this.props.onModelChange(this.state.originalModel);
    }
    this.props.handleCloseModal();
  }
  saveCounter = () => {
    if (this.props.isValid()) {
      this.props.handleCloseModal();
    } else {
      Toastr.error('There are errors in counter form.');
    }
  }
  render() {
    const { model, currentNode, parentNode, parentKeyList } = this.props;
    const { activeIndex } = this.state;
    const spanStyle = {
      color: 'green',
    };
    const style = {
      cursor: 'pointer',
    };
    // making countOptionList and byOptionList for counter node, below piece of code is to form those list by taking care of parent node and chain scenario case.
    const countOptionList = [];
    const byOptionList = [
      { text: 'Occurrence', value: 'occurrence' },
      { text: 'Transaction Value', value: 'txAmount' },
    ];

    const parentNodeType = _.get(model.nodes[parentNode], 'type') === 'scenarios' ? 'scenarios' : 'condition';

    if (parentNodeType === 'scenarios') {
      _.get(model.nodes[parentNode], 'data.scenarios', []).forEach((scenario, index) => {
        countOptionList.push({ text: `${_.get(scenario, 'name', `Scenario ${index + 1}`)}`, value: `${index + 1}` });
      });
    } else {
      _.get(model.nodes[parentKeyList[0]], 'data.scenarios', []).forEach((scenario, index) => {
        countOptionList.push({ text: `${_.get(scenario, 'name', `Scenario ${index + 1}`)} with ${_.get(model.nodes[parentNode], 'name', 'Condition')}`, value: `${index + 1}` });
      });
    }

    // filter countOptionList according number of scenarios.
    if (_.get(model.nodes[parentKeyList[0]], 'data.scenarios', []).length === 1) {
      countOptionList.splice(1, 1);
    }

    const countOptionTypes = countOptionList.reduce((result, o) => {
      result[o.value] = o.text;
      return result;
    }, {});
    const byOptionTypes = byOptionList.reduce((result, o) => {
      result[o.value] = o.text;
      return result;
    }, {});

    return (
      <div>
        <div className="model-button">
          <Grid>
            <Grid.Column textAlign="right">
              <Button.Group>
                <Button
                  onClick={this.cancelCounter}
                >
                  Cancel
                </Button>
                <Button.Or />
                <Button
                  positive
                  onClick={this.saveCounter}
                >
                  Save
                </Button>
              </Button.Group>
            </Grid.Column>
          </Grid>
        </div>
        {!_.isEmpty(_.get(this.props.error, 'counter', [])) &&
          <Message negative size="tiny">
            <Message.Header>
              <span className="validation-icon" />
              {this.props.error.counter[0]}
            </Message.Header>
          </Message>
        }
        <Accordion fluid styled>
          {_.get(model.nodes[currentNode], 'data.targets', []).map((countData, index) => {
            const count = countData.match(/\d+/g) !== null ? countData.match(/\d+/g)[0] : '1';
            const by = countData[0] === 'o' ? 'occurrence' : 'txAmount';
            return (
              <div key={index}>
                <Accordion.Title active={activeIndex === index} index={index} onClick={this.handleClick} key={`${index}${'title-countData'}`}>
                  <span>
                    <Icon name="dropdown" />
                    Count<span style={spanStyle}> {`${countOptionTypes[count]}`} </span> by {`${byOptionTypes[by]}`}
                  </span>
                </Accordion.Title>
                <Accordion.Content active={activeIndex === index} key={`${index}${'content-countData'}`}>
                  <div>
                    <Form>
                      <Grid columns="equal">
                        <Grid.Column width={4}>
                          <Button
                            disabled
                          >
                            COUNT
                          </Button>
                        </Grid.Column>
                        <Grid.Column width={4}>
                          <FormInputWithError
                            name="counter.count"
                            {...this.props}
                          >
                            <Form.Select
                              options={countOptionList}
                              value={count[0]}
                              onChange={(event, data) => this.handleCountChange(event, data, index)}
                            />
                          </FormInputWithError>
                        </Grid.Column>
                      </Grid>
                      <Grid columns="equal">
                        <Grid.Column width={4}>
                          <Button
                            disabled
                          >
                            BY
                          </Button>
                        </Grid.Column>
                        <Grid.Column width={4}>
                          <FormInputWithError
                            name="counter.by"
                            {...this.props}
                          >
                            <Form.Select
                              options={byOptionList}
                              value={by}
                              onChange={(event, data) => this.handleByChange(event, data, index)}
                            />
                          </FormInputWithError>
                        </Grid.Column>
                      </Grid>
                    </Form>
                    <Divider />
                    <Grid columns="equal">
                      <Grid.Column width={8}>
                        <Label
                          size="small"
                          color="violet"
                          style={style}
                          onClick={() => this.props.handleDeleteCount(index)}
                        >
                          <Icon name="trash alternate" /> Delete
                        </Label>
                      </Grid.Column>
                    </Grid>
                  </div>
                </Accordion.Content>
              </div>
            );
          })}
        </Accordion>
      </div>
    );
  }
}
